module.exports = __webpack_public_path__ + "img/bj-album-cover.7d046d8b.jpg";